<template>
  <div v-if="!loading" class="container">
    <p class="xiyawenjuan">西亚问卷</p>
    <van-image
      fit="cover"
      :src="backgroundImage"
      style="opacity: 0.6;width: 100%;height:15em"
    />

    <van-cell
      v-for="(item,index) in testSurveyList"
      :key="item.id"
      :title="index === 0 ? '第一部分' : '第二部分'"
      :label="item.subjectCount + '题 约' + (item.subjectCount * 6 / 60).toFixed(0) + '分钟'"
    >
      <template #icon>
        <van-icon size="48" :name="enableSurveyIcon" />
      </template>
      <template #right-icon>
        <van-button
          size="small"
          :type="item.finish === '1' ? 'default' : 'primary'"
          :disabled="item.finish === '1'"
          :url="'https://survey.xiya3333.com/s/' + item.id"
        >{{ item.finish === '1' ? '已完成' : '去答题' }}
        </van-button>
      </template>
    </van-cell>
  </div>
</template>
<script>
import { getTestSurvey } from '@/api/api'

export default {
  name: 'TestSurvey',
  data() {
    return {
      backgroundImage: process.env.NODE_ENV === 'development' ? '/320.jpg' : './320.jpg',
      enableSurveyIcon: process.env.NODE_ENV === 'development' ? '/surveyIcon.png' : './surveyIcon.png',
      disableSurveyIcon: process.env.NODE_ENV === 'development' ? '/surveyIconGray.png' : './surveyIconGray.png',
      testSurveyList: [],
      active: '1',
      loading: false
    }
  },
  mounted() {
    this.getTestSurvey()
  },
  methods: {
    getTestSurvey() {
      this.loading = true
      const toast = this.$toast.loading({
        message: '正在加载',
        forbidClick: true,
        loadingType: 'spinner'
      })
      setTimeout(() => {
        getTestSurvey({ openid: sessionStorage.getItem('openid') }).then(response => {
          const res = response.data
          if (res.code === 200) {
            res.data.forEach(item => {
              const subjectCount = JSON.parse(item.survey).children.length
              const survey = { name: item.name, id: item.id, subjectCount: subjectCount, finish: item.finish }
              this.testSurveyList.push(survey)
            })
          } else {
            this.$toast.fail(res.msg)
          }
          this.loading = false
          toast.clear()
        }
        )
      }, 300)
    }
  }
}
</script>
<style scoped>
.xiyawenjuan {
  font-size: 28px;
  position: absolute;
  top: -10px;
  left: 5%;
  z-index: 99;
  font-weight: 600;
  color: #fff;
  background: #2c3e50;
  padding: 5px 10px;
}

::v-deep .van-cell__title {
  text-align: left;
  margin-left: 5%;
  font-weight: 600;
}
</style>
